export default function ForbiddenPage() {
    return (
        <div style={{ padding: 24 }}>
            <h2>Not Authroised</h2>
            <p>You don’t have access to this page.</p>
            <p>If you should have access to this page please contact the system administrator.</p>
        </div>
    );
}
